export default __webpack_public_path__ + "static/media/balance.3cf5eec3.svg";